import { useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import HomePage from './components/pages/HomePage';
import StoriaPage from './components/pages/StoriaPage';
import VignetoPage from './components/pages/VignetoPage';
import ViniPage from './components/pages/ViniPage';
import IlBiuntPage from './components/pages/vini/il-biunt';
import GermoglioPage from './components/pages/vini/germoglio';
import ContactsPage from './components/pages/ContattiPage';
import TimelineScrollbar from "./components/TimelineScrollbar";
import LanguageWrapper from './components/LanguageWrapper';
import EtichettaAlimentareGermoglio from "./components/etichetta-alimentare/2025/etichetta-germoglio";
import EtichettaAlimentareBiunt from './components/etichetta-alimentare/2025/etichetta-biunt';
import { Helmet } from "react-helmet";
import '../src/i18n'; // importa subito dopo le librerie principali
import { useEffect } from 'react';
import i18n from './i18n';
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivacyPolicy from './components/pages/privacy';
import CookiePolicy from './components/pages/cookie';


function App() {
  const location = useLocation();

  // Percorsi in cui la navbar non deve essere mostrata
  const hideNavBarRoutes = ["/etichetta-alimentare/2025/germoglio", "/etichetta-alimentare/2025/il-biunt"];
  const shouldHideNavBar = hideNavBarRoutes.includes(location.pathname);
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, []);
  return (
    <>
      <Helmet>
        <title>Beverahills - Vini e Vigneto della Brianza</title>
        <meta name="description" content="Scopri Beverahills, il vigneto della Brianza che produce vini unici. Ogni dettaglio conta, ogni sorso racconta." />
        <meta name="keywords" content="vino, Brianza, vigneto, degustazione, enologia, terre lariane" />
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <TimelineScrollbar />
        <main className={`flex flex-grow items-center flex-col pb-10 px-4 ${shouldHideNavBar ? 'my-8' : 'my-24'} sm:px-6 lg:px-32 max-w-screen-2xl mx-auto`}>
          <Routes>
            <Route path="/" element={<Navigate to="/it" replace />} />

            <Route path="/:lang" element={<LanguageWrapper />}>
              <Route index element={<HomePage />} />
              <Route path="storia" element={<StoriaPage />} />
              <Route path="vigneto" element={<VignetoPage />} />
              <Route path="vini" element={<ViniPage />} />
              <Route path="vini/il-biunt" element={<IlBiuntPage />} />
              <Route path="vini/germoglio" element={<GermoglioPage />} />
              <Route path="contatti" element={<ContactsPage />} />

            </Route>

            <Route path="/etichetta-alimentare/2025/germoglio" element={<EtichettaAlimentareGermoglio />} />
            <Route path="/etichetta-alimentare/2025/il-biunt" element={<EtichettaAlimentareBiunt />} />

            <Route path="*" element={<Navigate to="/it" replace />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="cookie" element={<CookiePolicy />} />
          </Routes>
        </main>
        {!shouldHideNavBar && <Footer />}

      </div>
    </>
  );
}

export default App;
